import Analytics from "../lib/analytics/Analytics";
import { EventType, LogEvent, TimingEvent } from "../types/Analytics";
import { IFormSchema } from "../types/genericComponents";
import { getWebsiteEnvironment } from "./constants/EnvironmentConstants";
import { HOME_PAGE_URL } from "./constants/GlobalConstants";
import { allLocales, COUNTRY } from "./constants/LocaleAndCountryConstants";
import { OUR_PARTNERS_TABS } from "./enums";

export const getLocaleFromPathname = (pathname: string) => {
    let currentLocale = getWebsiteEnvironment().defaultLocale;
    let pathNameWithoutLocale = pathname;
    let pathnameHasLocale = allLocales.some((locale) => {
        if (pathname.startsWith(`/${locale}/`) || pathname === `/${locale}`) {
            currentLocale = locale;
            let pathArray = pathname.split("/").filter((path) => path);
            pathArray.shift();
            pathNameWithoutLocale = `/${pathArray.join("/")}`;
            return true;
        } else {
            return false;
        }
    });
    return { pathnameHasLocale, currentLocale, pathNameWithoutLocale };
};

export const nextImageLoader = ({ src, width }: any): string => {
    if (width) {
        return src + `?&w=${width}&q=75`;
    }
    return src;
};
export const multipleClassName = <T>(...classNames: T[]): string => {
    return classNames.join(" ");
};

export const getCountryFromLocale = (
    locale: string | undefined | null
): string => {
    const country = locale?.split("-")[1];
    return country ? country : COUNTRY.INDIA;
};
export const debounce = <T>(func: Function, timeout = 500) => {
    let timer: NodeJS.Timeout;

    return (
        args: T | undefined = undefined,
        to: number | undefined = undefined
    ) => {
        clearTimeout(timer);
        timer = setTimeout(
            () => {
                func(args);
            },
            to ? to : timeout
        );
    };
};




export const isDataInvalid = (
    formData: IFormSchema,
    validateOnChange: Function,
    setFormData: Function
) => {
    let invalidForm: boolean = false;
    for (let key of Object.keys(formData)) {
        const { error, hasError } = validateOnChange(key, formData);
        console.log(key, error, hasError);
        
        if (hasError && !formData[key].hidden) {
            formData[key].error = error;
            invalidForm = true;
        } else {
            formData[key].error = "";
        }
    }
    setFormData({ ...formData });
    return invalidForm;
};
export const transformToString = async (obj: any) => {
    return JSON.parse(await obj.Body.transformToString());
};

export const downloadURI = (uri: string, name: string) => {
    var link = document.createElement("a");
    link.setAttribute("target", "_blank")
    link.download = name;
    link.href = uri;
    link.click();
    link.remove();
}

export const zoLogger = (() => {
    const checkIfLogsEnabled = () => {
        return process.env.LOGS_ENABLED;
    }

    const isDev = process.env.NEXT_PUBLIC_ENV === 'development';    
    
    const print = ( isProd=false, ...messages : any ) => {
        if(isProd){
            console.log(...messages)
            return
        }
        if( checkIfLogsEnabled() || isDev ) {
            console.log(...messages);
        }
    };
    
    return {
        log:(...args : any)=>print(false,...args),
        productionLog:(...args : any)=>print(true,...args)
    };
})();

export const userAction = (event : LogEvent | TimingEvent, action : Function = () => {}, eventType : EventType = EventType.LogEvent)=>{    
    switch (eventType) {
        case EventType.LogEvent : 
        Analytics.getInstance().logEvent(event as LogEvent);
        break;
        case EventType.TimingEvent : 
        Analytics.getInstance().timingEvent(event as TimingEvent);
        break;
    }
    action()
}

export const getFormSchemaWithLocalisedData = (jsonData : any,formSchema : IFormSchema)=>{
    Object.keys(jsonData).map((key)=>{
        if(key in formSchema) {
            switch (formSchema[key].type) {
                case "select" : 
                formSchema[key].options = jsonData[key].options || []
                default : 
                formSchema[key].label = jsonData[key].label;
            }
        }
    })
    console.log(formSchema);
    
return formSchema
}

export const setTabsInSessionStorage = (tab : OUR_PARTNERS_TABS) => {
    sessionStorage.setItem("ourPartnersTab", tab)
}

export const getTabsFromSessionStorage = () => {
    return sessionStorage.getItem("ourPartnersTab") as OUR_PARTNERS_TABS
}

export const getUrlWithLocale = (locale: string, pathName: string): string => {
    let pathNameWithSlash = pathName

    if (!pathName.startsWith("/")) {
        pathNameWithSlash = `/${pathName}`
    } else if (pathName === HOME_PAGE_URL) {
        pathNameWithSlash = ""
    }

    return `/${locale}${pathNameWithSlash}`
}
